import React from 'react';
import {Tabs} from 'antd';
import ListAuthorityList from './ListAuthorityList.js';
import ListAuthorityDetail from './ListAuthorityDetail.js';

const { TabPane } = Tabs;
class ListAuthority extends React.Component{
  
    constructor(props) {
      super(props);  
      this.state={
        activeKey:"1",
        params:null,
        isfalse:true
      }
    }
    callback(activeKey,type,params){
        if(type == "details"){
          this.state.params = params;
          this.state.isfalse=true;
        }
        if(type == "add"){
          this.state.params = null;
        }
      this.setState({activeKey:activeKey});
    }
    
    render(){
      let {isfalse}=this.state;
        return(
          <div>
              <Tabs type="card" activeKey={this.state.activeKey} onChange= {this.callback.bind(this)}>
              <TabPane tab="黑白名单列表" key="1">
                <ListAuthorityList buttonList={this.props.buttonList}  callback = {this.callback.bind(this)}/>
              </TabPane>
              <TabPane tab="黑白名单详情" key="2">
                 <ListAuthorityDetail buttonList={this.props.buttonList}  isfalse={isfalse} params = {this.state.params} callback = {this.callback.bind(this)}/>
              </TabPane>
            </Tabs>
          </div>
        )
    }
}
export default ListAuthority;